<ng-container>

    <form accept-charset="UTF-8" (ngSubmit)="userCreationSubmit(consultDoctorForm)" #consultDoctorForm="ngForm">
        <div class="ui-g">
            <div class="ui-g-12">
                <p class="heading3 egd-color  m-3"><b>Please fill in the following details</b></p>
                <div class="ui-g container">
                    <div class="ui-g-12 custom-offset ui-lg-5">
                        <div class="margint">
                            <label class="ui-g-12 font-weight-bold" for="vendor">Vendor*</label>
                            <p-dropdown id="dropdown_v" name="dropdown_v" [disabled]="this.createUser.display"
                                [options]="this.createUser.other_data.vendor_list"
                                [(ngModel)]="this.createUser.other_data.selected_vendor_data" #vendor="ngModel"
                                styleClass="input-pill1 input-dropdown-pill mb-3 pl-3" [filter]="true"
                                (onChange)="onChangeVendor()" [filterBy]='"label"' placeholder="Select Vendor" required>
                            </p-dropdown>
                            <div *ngIf="vendor.invalid && (vendor.dirty || vendor.touched)" class="ui-g-12">
                                <div *ngIf="vendor.errors.required" class="ui-g-12 alert alert-danger m-2" role="alert">
                                    Vendor is required.
                                </div>
                            </div>
                        </div>
                        <div class="margint">
                            <label class="ui-g-12 font-weight-bold" for="dropdown_h_and_c">Consultation Type*</label>
                            <p-dropdown id="dropdown_h_and_c" name="dropdown_h_and_c"
                                [disabled]="this.createUser.display"
                                [options]="this.createUser.other_data.consultation_type_list"
                                [(ngModel)]="this.createUser.other_data.selected_consultation_type"
                                #consultation_type="ngModel" styleClass="input-pill1 input-dropdown-pill mb-3 pl-3"
                                [filter]="true" (onChange)="onChangeConsultationType()" [filterBy]='"label"'
                                placeholder="Select Consultation Type" required>
                            </p-dropdown>
                            <div *ngIf="consultation_type.invalid && (consultation_type.dirty || consultation_type.touched)"
                                class="ui-g-12">
                                <div *ngIf="consultation_type.errors.required" class="ui-g-12 alert alert-danger"
                                    role="alert">
                                    Consultation type is required.
                                </div>
                            </div>
                        </div>
                        <div class="margint">
                            <!-- <div class="ui-g"> -->
                            <label class="ui-g-12 font-weight-bold ml-3" for="fname">
                                Name*</label>

                            <div class="ui-g-12 ui-lg-6">
                                <input type="text" pInputText class="form-control rounded-pill1" id="fname"
                                    [disabled]="this.createUser.display" name="fname"
                                    [(ngModel)]="this.createUser.supporCreateUser.first_name" #first_name="ngModel"
                                    aria-describedby="fname" placeholder="First Name*"
                                    [pKeyFilter]="this.createUser.other_data.regExp.name_input" required>
                                <div *ngIf="first_name.invalid && (first_name.dirty || first_name.touched)"
                                    class="ui-g-12">
                                    <div *ngIf="first_name.errors.required" class="ui-g-12 alert alert-danger m-2"
                                        role="alert">
                                        First name is required.
                                    </div>
                                    <div *ngIf="first_name.errors.FieldValidator" class="ui-g-12 alert alert-danger m-2"
                                        role="alert">
                                        Invalid First name.
                                    </div>
                                </div>
                            </div>
                            <div class="ui-g-12 ui-lg-6">
                                <input type="text" pInputText class="form-control rounded-pill1 mt-2 mt-md-0"
                                    [disabled]="this.createUser.display" id="mname" name="mname"
                                    [pKeyFilter]="this.createUser.other_data.regExp.name_input"
                                    [(ngModel)]="this.createUser.supporCreateUser.middle_name" #mname="ngModel"
                                    aria-describedby="mname" placeholder="Middle Name">
                            </div>
                            <!-- .</div> -->
                        </div>
                        <div class="margint">
                            <input type="text" pInputText class="form-control rounded-pill2" id="lname" name="lname"
                                [(ngModel)]="this.createUser.supporCreateUser.last_name" #last_name="ngModel"
                                aria-describedby="lname" placeholder="Last Name*" [disabled]="this.createUser.display"
                                [pKeyFilter]="this.createUser.other_data.regExp.name_input" required>
                            <div *ngIf="last_name.invalid && (last_name.dirty || last_name.touched)"
                                class="ui-g-12 px-0">
                                <div *ngIf="last_name.errors.required" class="ui-g-12 alert alert-danger m-2"
                                    role="alert">
                                    Last name is required.
                                </div>
                                <div *ngIf="last_name.errors.FieldValidator" class="ui-g-12 alert alert-danger m-2"
                                    role="alert">
                                    Invalid Last name.
                                </div>
                            </div>
                        </div>
                        <div class="margint">
                            <label class="ui-g-12 font-weight-bold" for="country">Country*</label>
                            <p-dropdown id="country" name="country" [options]="this.createUser.other_data.countries"
                                styleClass="input-pill1 input-dropdown-pill" [filter]="true" [disabled]="true"
                                [(ngModel)]="this.createUser.other_data.selected_primary_country"
                                (onChange)="onChangeCountry()" #country="ngModel" [filterBy]='"label"'
                                placeholder="Select Country" required>
                            </p-dropdown>
                            <div *ngIf="country.invalid && (country.dirty || country.touched)" class="ui-g-12">
                                <div *ngIf="country.errors.required" class="ui-g-12 alert alert-danger m-2"
                                    role="alert">
                                    Country is required.
                                </div>
                            </div>
                        </div>
                        <div class="margint">
                            <label class="ui-g-12 font-weight-bold" for="state">State*</label>
                            <p-dropdown id="state" name="state" [options]="this.createUser.other_data.states"
                                styleClass="input-pill1 input-dropdown-pill mb-3 pl-3" [filter]="true"
                                [(ngModel)]="this.createUser.other_data.selected_state" #state="ngModel"
                                [filterBy]='"label"' placeholder="Select State" required>
                            </p-dropdown>
                            <div *ngIf="state?.invalid && (state?.dirty || state?.touched)" class="ui-g-12">
                                <div *ngIf="state?.errors.required" class="ui-g-12 alert alert-danger m-2" role="alert">
                                    State is required.
                                </div>
                            </div>
                        </div>
                        <div class="margint">
                            <div>
                                <label class="ui-g-12 font-weight-bold" for="primaryno">Primary Mobile
                                    No.*</label>
                                <div class="form-group">
                                    <div class="phone-input ">
                                        <div class="phone-pill">
                                            <select name="country1"
                                                class="input-group-text prepend-of-append-prepend box-shadow-none box-shadow-input width-35p"
                                                [(ngModel)]="this.createUser.other_data.selected_primary_country.phone_code"
                                                #prim_country="ngModel" required>
                                                <option value="" class="font-weight-bolder" disabled selected>Country
                                                    Code*</option>
                                                <option
                                                    *ngFor="let country of this.createUser.other_data.countries_codes"
                                                    value={{country.value}}>
                                                    {{country.label}}
                                                </option>
                                            </select>
                                            <input type="text" pInputText class="form-control rounded-pill1"
                                                [disabled]="this.createUser.display" id="primaryno" name="primaryno"
                                                aria-describedby="primaryno"
                                                [(ngModel)]="this.createUser.other_data.primary_contact_no"
                                                #primary_no="ngModel"
                                                [pKeyFilter]="this.createUser.other_data.regExp.phoneNumber"
                                                [pattern]="this.createUser.other_data.regExp.phoneNumber" maxlength="20"
                                                 placeholder="Primary Number" required>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="primary_no?.invalid && (primary_no?.dirty || primary_no?.touched)"
                                class="ui-g-12 pl-2">
                                <div *ngIf="primary_no.errors?.required" class="ui-g-12 alert alert-danger m-2"
                                    role="alert">
                                    Primary Phone No. is required.
                                </div>
                                <!-- <div *ngIf="primary_no.errors?.maxlength" class="ui-g-12 alert alert-danger m-2"
                                    role="alert">
                                    Phone number should be of 10 digits.
                                </div> -->
                                <div *ngIf="primary_no.errors?.pattern" class="ui-g-12 alert alert-danger m-2"
                                    role="alert">
                                    Only Numbers are allowed.
                                </div>
                            </div>
                        </div>
                        <div class="margint">
                            <div>
                                <label class="ui-g-12 font-weight-bold" for="secondaryno">Secondary Mobile
                                    No.*</label>
                                <div class="form-group">
                                    <div>
                                        <div class="phone-pill">
                                            <select name="country"
                                                class="input-group-text prepend-of-append-prepend box-shadow-none box-shadow-input width-35p"
                                                [(ngModel)]="this.createUser.other_data.selected_secondary_country.phone_code"
                                                #sec_country="ngModel" required>
                                                <option value="" class="font-weight-bolder" disabled selected>Country
                                                    Code*</option>
                                                <option
                                                    *ngFor="let country of this.createUser.other_data.countries_codes"
                                                    value={{country.value}}>
                                                    {{country.label}}
                                                </option>
                                            </select>
                                            <input type="text" pInputText class="form-control rounded-pill1"
                                                [disabled]="this.createUser.display" id="secondaryno" name="secondaryno"
                                                aria-describedby="secondaryno"
                                                [(ngModel)]="this.createUser.other_data.secondary_contact_no"
                                                #secondary_no="ngModel"
                                                [pKeyFilter]="this.createUser.other_data.regExp.phoneNumber"
                                                [pattern]="this.createUser.other_data.regExp.phoneNumber" maxlength="20"
                                                 placeholder="Secondary Number">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="secondary_no?.invalid" class="ui-g-12 pl-2">
                                <!-- <div *ngIf="secondary_no.errors?.maxlength" class="ui-g-12 alert alert-danger m-2"
                                    role="alert">
                                    Phone number should be of 10 digits.
                                </div> -->
                                <div *ngIf="secondary_no.errors?.pattern" class="ui-g-12 alert alert-danger m-2"
                                    role="alert">
                                    Only Numbers are allowed.
                                </div>
                            </div>
                        </div>
                        <div class="margint">
                            <label class="ui-g-12 font-weight-bold" for="gender">Gender*</label>
                            <p-dropdown id="gender" name="gender" [options]="this.gender_list"
                                styleClass="input-pill1 input-dropdown-pill"
                                [(ngModel)]="this.createUser.supporCreateUser.gender" #gender="ngModel"
                                [disabled]="this.createUser.display" placeholder="Select Gender" required>
                            </p-dropdown>
                            <div *ngIf="(gender.invalid && (gender.dirty || gender.touched))" class="ui-g-12">
                                <div *ngIf="gender.errors.required" class="ui-g-12 alert alert-danger m-2" role="alert">
                                    Gender is required.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="ui-g-12 ui-lg-1"></div>
                    <div class="ui-g-12 ui-lg-5">
                        <div class="margint">
                            <label class="ui-g-12 font-weight-bold " for="binumber">
                                Booking Identification Number(CRN No.)*</label>
                            <input type="text" pInputText class="form-control rounded-pill1" id="binumber"
                                [(ngModel)]="this.createUser.supporCreateUser.booking_id_no" #booking_id_no="ngModel"
                                [disabled]="this.createUser.display" name="binumber" aria-describedby="binumber"
                                placeholder="Booking No.*" required>
                            <div *ngIf="booking_id_no.invalid && (booking_id_no.dirty || booking_id_no.touched)"
                                class="ui-g-12">
                                <div *ngIf="booking_id_no.errors.required" class="ui-g-12 alert alert-danger m-2"
                                    role="alert">
                                    Booking Id number is required.
                                </div>
                            </div>
                        </div>
                        <div class="margint">
                            <label class="ui-g-12 font-weight-bold" for="date">Date of Birth*</label>
                            <p-calendar id="dob" class="notranslate" name="dob" id="dob" [style]="{'width':'100%'}"
                                [maxDate]="this.createUser.other_data.currentDate"
                                [inputStyle]="{'width':'100%','border-radius':'50rem','padding':'7px'}"
                                [(ngModel)]="this.createUser.supporCreateUser.date_of_birth_date"
                                #date_of_birth="ngModel" placeholder="Date of Birth (DD/MM/YYYY)" dateFormat="dd/mm/yy"
                                [disabled]="this.createUser.display" [monthNavigator]="true" [yearNavigator]="true"
                                yearRange="1940:2025" [showIcon]="false" required>
                            </p-calendar>
                            <div *ngIf="date_of_birth.invalid && (date_of_birth.dirty || date_of_birth.touched)"
                                class="ui-g-12">
                                <div *ngIf="date_of_birth.errors.required" class="ui-g-12 alert alert-danger m-2"
                                    role="alert">
                                    Date of Birth is required.
                                </div>
                            </div>
                        </div>


                        <div class="margint">
                            <label class="ui-g-12 font-weight-bold" for="email">Email<span
                                    *ngIf="this.createUser.other_data.selected_vendor_data.vendor_name=='Help And Care'">*</span></label>
                            <input id="email" pInputText name="email" type="email" class="form-control rounded-pill1"
                                [disabled]="this.createUser.display"
                                [(ngModel)]="this.createUser.supporCreateUser.e_email" #email="ngModel"
                                aria-describedby="email" FieldValidator="email" placeholder="Enter your email"
                                [required]="this.createUser.other_data.selected_vendor_data.vendor_name=='Help And Care'">
                            <div *ngIf="(email.invalid)" class="ui-g-12">
                                <div *ngIf="email.errors.FieldValidator" class="ui-g-12 alert alert-danger m-2"
                                    role="alert">
                                    Invalid Email.
                                </div>
                            </div>
                        </div>
                        <div class="margint">
                            <label class="ui-g-12 font-weight-bold" for="address">
                                Mailing Address</label>
                            <input type="text" pInputText class="form-control rounded-pill1" id="address" name="address"
                                [disabled]="this.createUser.display"
                                [(ngModel)]="this.createUser.supporCreateUser.address" #address="ngModel"
                                aria-describedby="address" placeholder="Address">
                        </div>
                        <div class="margint">
                            <label class="ui-g-12 font-weight-bold" for="p_country">Permanent Country*</label>
                            <p-dropdown id="p_country" name="p_country" [options]="this.createUser.other_data.countries"
                                styleClass="input-pill1 input-dropdown-pill" [filter]="true"
                                [(ngModel)]="this.createUser.other_data.selected_permanent_country"
                                (onChange)="onChangePermanentCountry()" #p_country="ngModel" [filterBy]='"label"'
                                placeholder="Select Country" required>
                            </p-dropdown>
                            <div *ngIf="p_country.invalid && (p_country.dirty || p_country.touched)" class="ui-g-12">
                                <div *ngIf="p_country.errors.required" class="ui-g-12 alert alert-danger m-2"
                                    role="alert">
                                    Permanent Country is required.
                                </div>
                            </div>
                        </div>
                        <div class="margint">
                            <label class="ui-g-12 font-weight-bold" for="p_state">Permanent State*</label>
                            <p-dropdown id="p_state" name="p_state" [options]="this.createUser.other_data.p_states"
                                styleClass="input-pill1 input-dropdown-pill mb-3 pl-3" [filter]="true"
                                [(ngModel)]="this.createUser.other_data.selected_permanent_state" #p_state="ngModel"
                                [filterBy]='"label"' placeholder="Select State" required>
                            </p-dropdown>
                            <div *ngIf="p_state?.invalid && (p_state?.dirty || p_state?.touched)" class="ui-g-12">
                                <div *ngIf="p_state?.errors.required" class="ui-g-12 alert alert-danger m-2"
                                    role="alert">
                                    Permanent State is required.
                                </div>
                            </div>
                        </div>
                        <div class="margint">
                            <label class="ui-g-12 font-weight-bold" for="p_address">
                                Permanent Address*</label>
                            <input type="text" pInputText class="form-control rounded-pill1" id="p_address"
                                name="p_address" [disabled]="this.createUser.display"
                                [(ngModel)]="this.createUser.supporCreateUser.permanent_address" #p_address="ngModel"
                                aria-describedby="address" placeholder="Address">
                            <div *ngIf="p_address?.invalid && (p_address?.dirty || p_address?.touched)" class="ui-g-12">
                                <div *ngIf="p_address?.errors.required" class="ui-g-12 alert alert-danger m-2"
                                    role="alert">
                                    Permanent address is required.
                                </div>
                            </div>
                        </div>
                        <div class="margint">
                            <input type="checkbox" [(ngModel)]="this.has_consented" id="consent" name="consent">
                            <label class="form-check-label" for="customCheck1">
                                Patient Consent
                            </label>
                        </div>


                    </div>
                </div>
            </div>
        </div>



    </form>
    <div class="ui-g text-center paddingtp">
        <div>
            <button type="button"  [disabled]="consultDoctorForm.invalid || isPosting()"
                (click)="openDialog()"
                class="btn btn-default btn-primary egd-theme-white-bg-btn egd-login-signup-buttons mx-2 p-2">
                <span class="egd-theme-white-bg-btn-label">
                    Continue
                </span>
            </button>
        </div>
    </div>
    <div class="ui-md-12 text-center" *ngIf="this.createUser.create_api_result.PromiseResult.success">
        <p class="heading4 alert-success1">
            {{this.createUser.create_api_result.PromiseResult.data.message}}
        </p>
    </div>
</ng-container>

<p-dialog *ngIf="this.createUser.display" header="Patient Details" [(visible)]="this.createUser.display"
    [style]="{ width: '60vw' }">
    <div class="flex py-2">
        <div class="ui-g">
            <div class="ui-g-12">
                <div class="row">
                    <div class="ui-g-12 ui-lg-4">
                        <span class="font-weight-bold">First Name :
                        </span>{{this.createUser.supporCreateUser.first_name}}
                    </div>
                    <div class="ui-g-12 ui-lg-4">
                        <span class="font-weight-bold">Middle Name :
                        </span>{{this.createUser.supporCreateUser.middle_name || "N/A"}}
                    </div>
                    <div class="ui-g-12 ui-lg-4">
                        <span class="font-weight-bold">Last Name : </span>{{this.createUser.supporCreateUser.last_name}}
                    </div>
                </div>
                <div class="row">
                    <div class="ui-g-12 ui-lg-4">
                        <span class="font-weight-bold">Country :
                        </span>{{this.createUser.other_data.selected_primary_country.name}}
                    </div>
                    <div class="ui-g-12 ui-lg-4">
                        <span class="font-weight-bold">State :</span>{{this.createUser.other_data.selected_state.name}}
                    </div>

                    <div class="ui-g-12 ui-lg-4">
                        <span class="font-weight-bold">Phone Number
                        </span>{{this.createUser.other_data.selected_primary_country.phone_code +
                        this.createUser.other_data.primary_contact_no}}
                    </div>
                </div>
                <div class="row">
                    <div class="ui-g-12 ui-lg-4">
                        <span class="font-weight-bold">Permanent Country :
                        </span>{{this.createUser.other_data.selected_permanent_country.name}}
                    </div>
                    <div class="ui-g-12 ui-lg-4">
                        <span class="font-weight-bold">Permanent State
                            :</span>{{this.createUser.other_data.selected_permanent_state.name}}
                    </div>

                    <!-- <div class="ui-g-12 ui-lg-4">
                        <span class="font-weight-bold">Consultation Type
                        </span>{{this.createUser.other_data.selected_consultation_type.label}}
                    </div> -->
                </div>
                <div class="row">
                    <div class="ui-g-12 ui-lg-4">
                        <span class="font-weight-bold">Booking Id :
                        </span>{{this.createUser.supporCreateUser.booking_id_no}}
                    </div>
                </div>
                <div class="row">
                    <div class="ui-g-12 ui-lg-4">
                        <span class="font-weight-bold">Vendor :
                        </span>{{this.createUser.other_data.selected_vendor_data.vendor_name}}
                    </div>
                    <div class="ui-g-12 ui-lg-4">
                        <span class="font-weight-bold">Address : </span>{{this.createUser.supporCreateUser.address ||
                        "N/A"}}
                    </div>
                    <div class="ui-g-12 ui-lg-4">
                        <span class="font-weight-bold">Email : </span>{{this.createUser.supporCreateUser.e_email ||
                        "N/A"
                        }}
                    </div>
                </div>
                <div class="row">
                    <div class="ui-g-12 ui-lg-4">
                        <span class="font-weight-bold">Gender : </span>{{this.createUser.supporCreateUser.gender}}
                    </div>
                    <div class="ui-g-12 ui-lg-4">
                        <span class="font-weight-bold">Date of Birth : </span>{{
                        this.createUser.supporCreateUser.date_of_birth_date | date: 'mediumDate'}}
                    </div>
                    <div class="ui-g-12 ui-lg-4">
                        <span class="font-weight-bold">Permanent Address : </span>{{
                        this.createUser.supporCreateUser.permanent_address}}
                    </div>
                </div>
                <div class="row">
                    <div class="ui-g-12 ui-lg-4">
                        <span class="font-weight-bold">Secondary Phone Number
                        </span>{{this.createUser.other_data.selected_secondary_country.phone_code +
                        this.createUser.other_data.secondary_contact_no}}
                    </div>
                </div>
            </div>
        </div>
        <div class="ui-g-12 text-center">
            <button (click)="closeDialog()" style="margin-right:3px;"
                class="btn btn-default btn-primary egd-theme-white-bg-btn egd-login-signup-buttons">
                <span class="egd-theme-white-bg-btn-label">
                    Edit
                </span>
            </button>
            <button type="submit" (click)="userCreationSubmit(consultDoctorForm)"
                class="btn btn-default btn-primary egd-theme-white-bg-btn egd-login-signup-buttons">
                <span class="egd-theme-white-bg-btn-label">
                    Submit
                </span>
            </button>
        </div>
        <div class="ui-g-12">
            <div class="mt-3 mx-2">
                <div class="row">
                    <app-loading class="ui-g-12 text-center" *ngIf="isPosting()" type="SMALL_LOADER">
                    </app-loading>
                </div>

                <app-error-messages [api_result]="this.createUser.create_api_result"></app-error-messages>

            </div>
        </div>

    </div>
</p-dialog>